import { css, keyframes } from '@emotion/react'
import { styled } from '@mui/material'

export const FlexWrapper = styled('section')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
`

export const DrawerContent = styled('div')`
  padding: 0 30px;
  width: 100%;
`

// Define the keyframes for spinning
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

// CSS for the spinning animation
export const rotateIconStyle = css`
  display: inline-block;
  animation: ${spin} 2s linear infinite;
`
